export default "__VITE_ASSET__Bx7mvG5v__"